import * as yup from 'yup';
import { setIn } from 'final-form';
import {Schema} from 'yup';

type SchemaFunction<T> = () => Schema<T>

type SchemaProps<T> = Schema<T> | SchemaFunction<T>;

function isFunction(x: any): x is SchemaFunction<any> {
  return typeof x === 'function'
}

const validate = (schema: SchemaProps<any>) => async (values: any) => {
  if (isFunction(schema)) {
    // eslint-disable-next-line no-param-reassign
    schema = schema();
  }
  try {
    await schema.validate(values, { abortEarly: false });
  } catch (e) {
    return e.inner.reduce((errors: object, error: { path: string; message: any; }) => {
      return setIn(errors, error.path, error.message);
    }, {});
  }
  return null;
};

export default validate;
